<template>
    <div :class="['gallery__list', images.length === 1 ? 'gallery__list--single' : (images.length == 2 || images.length == 4 ? 'gallery__list--large' : '')]">
        <galleryCard v-for="(image, index) in images" :key="image.src" :caption="image.caption" :img="image.img" :class="[``,index === images.length - 1 && images.length % 2 !== 0 ? 'gallery__card__last-child' : '']" :gallery-size="images.length" />
    </div>
</template>

<script>
import galleryCard from './gallery-card.vue';

export default {
    components: { galleryCard },
    props: {
        images: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        return {};
    },
};
</script>
